import { render, staticRenderFns } from "./IdlResume.vue?vue&type=template&id=7f0e2572&scoped=true"
import script from "./IdlResume.vue?vue&type=script&lang=js"
export * from "./IdlResume.vue?vue&type=script&lang=js"
import style0 from "./IdlResume.vue?vue&type=style&index=0&id=7f0e2572&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0e2572",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f0e2572')) {
      api.createRecord('7f0e2572', component.options)
    } else {
      api.reload('7f0e2572', component.options)
    }
    module.hot.accept("./IdlResume.vue?vue&type=template&id=7f0e2572&scoped=true", function () {
      api.rerender('7f0e2572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customize/Back/IdlResume.vue"
export default component.exports